import React, { useState, useRef, useEffect } from 'react'
import styled from 'styled-components'

import Link from 'components/link'
import WarningModal from 'src/components/warningModal'

import { DesktopOnly } from 'components/styled'
import { TABS } from 'components/tabLayout/constants'

import LogoutOutline from 'static/icons/logout-outline.svg'
import MODAL from 'utils/modals'
import withRootContext from 'context/withRootContextHOC'
import { assetPrefix } from 'config/env_config'

const DesktopMenuContainer = styled(DesktopOnly)`
  display: flex;
  align-items: center;
  color: var(--cobasi-blue-light-8);
  cursor: pointer;
  position: relative;
  margin-right: -10px;
`

const UserIconContainer = styled.a`
  display: flex;
  width: 2.4rem;
  height: 2.4rem;
  ${props => props.marginTop && 'margin-top: 30px'}
`

const UserName = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: fit-content;
  max-width: 200px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 16px 0 10px;

  u{
    font-size:12px;
  }
`

export const UserLinks = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--the-white);
`

export const Tab = styled.section`
  display: flex;
  align-items: center;
  gap: 8px;
  ${({ secondary }) => secondary && `
      color: var(--cobasi-blue-light-8);
      svg {
        path {
          fill: var(--cobasi-blue-light-8);
        }
      }
  `}

  a {
    color: inherit;
    display: block;
    text-decoration: none;
    font-size: 16px;
    font-weight: 600;
    font-family: var(--primary-font);
    color: var(--gray-5);
    line-height: 19.2px;
  }

  & + & {
    margin-top: 16px;
  }
`

const DropDown = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  min-width: 185px;
  height: fit-content;
  gap: 16px;
  padding: 16px;
  background-color: var(--the-white);
  border: 1px solid var(--silver);
  border-radius: 24px;
  position: absolute;
  left: -26px;
  top: 32px;
`

const IconStyled = styled.img`
  width: 24px;
  height: 24px;
  margin-bottom: -6px;
`

const UserIcon = props => (
  <UserIconContainer {...props}>
    <DesktopOnly>
      <img src={`${assetPrefix}/static/icons/user-circle.svg`} />
    </DesktopOnly>
  </UserIconContainer>
)

const LoggedUser = ({ context: { firstName, toggleModalSheet, logoutUser } }) => {
  const openAuthModal = () => toggleModalSheet(MODAL.LOGIN_MODAL({ onCancel: toggleModalSheet, callback: toggleModalSheet }))
  const { icon, title, body, cancelLabel, confirmLabel } = MODAL.LOGGOUT_MODAL()

  const [showDropdown, setShowDropdown] = useState(false)
  const [isLogoutModalVisible, setLogoutModalVisible] = useState(false)
  const menuRef = useRef(null)
  const buttonRef = useRef(null)

  const handleLogout = async () => {
    setLogoutModalVisible(false)
    await logoutUser()
  }

  const handleLogoutModalToggle = () => setLogoutModalVisible(!isLogoutModalVisible)
  const handleToggleDropdown = () => setShowDropdown(!showDropdown)

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target)) {
      setShowDropdown(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)

    // Cleanup the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <>
      <DesktopMenuContainer onClick={() => { if (!firstName) openAuthModal() }} data-test='button-menu-login-logout'>
        <UserIcon />
        <UserName title={firstName || 'Entre ou Cadastre-se'} data-test='text-login-register'>
          {firstName ? `Olá, ${firstName}` : 'Bem-vindo'}
          {!firstName && (
            <div>
              <u>Entre ou Cadastre-se</u>
            </div>
          )}
        </UserName>

        {firstName && (
          <div onClick={() => handleToggleDropdown()} ref={buttonRef}>
            {showDropdown ? (
              <IconStyled src={`${assetPrefix}/static/icons/chevron-up-blue.svg`} alt='' />
            ) : (
              <IconStyled src={`${assetPrefix}/static/icons/chevron-down-blue.svg`} alt='' />
            )}
          </div>
        )}

        {showDropdown && (
          <DropDown ref={menuRef}>
            <UserLinks data-test='userLinks'>
              {
                TABS.map((tab, index) => {
                  if (tab.hideOnApp) return
                  return (
                    <Tab key={'menu-tab-item-000' + index}>
                      {tab.icon}
                      <Link href={tab.href}><a onClick={() => handleToggleDropdown()}>{tab.menuTitle ?? tab.title}</a></Link>
                    </Tab>
                  )
                })
              }
              {firstName && <Tab onClick={() => handleLogoutModalToggle()}><LogoutOutline /><a onClick={() => handleToggleDropdown()}>Sair da conta</a></Tab>}
            </UserLinks>
          </DropDown>
        )}
      </DesktopMenuContainer>

      {isLogoutModalVisible &&
        <WarningModal
          visible={isLogoutModalVisible}
          title={title}
          titleSize='16px'
          icon={icon}
          onCancel={handleLogoutModalToggle}
          onConfirm={handleLogout}
          confirmLabel={confirmLabel}
          cancelLabel={cancelLabel}
          dataTest='modal-warning-loggout'
          outlineCancelButton
        >
          {body}
        </WarningModal>}

    </>
  )
}

export default withRootContext(LoggedUser)
